<app-connection-object-address
  [areaType]="areaType"
  [disable]="disable"
  [connectionObjectForm]="connectionObjectForm"
  [askForDevelopmentArea]="!disableDevelopmentArea"
  (gisData)="gisDataEvent.emit($event)"></app-connection-object-address>

<section *ngIf="noCompanyLocation$ | async">
  <h4>Netzbetreiber / Messstellenbetreiber</h4>
  <span class="alert alert-danger">Kein Betriebsbereich für dieses Anschlussobjekt gefunden.</span>
</section>

<section *ngIf="noCompanyLocation$ | async">
  <span class="alert alert-danger">
    Die Sparte {{ areaType | areaText }} ist an dieser Adresse nicht verfügbar.
  </span>
</section>

<form *ngIf="additionalInfoForm && hasData && !(noCompanyLocation$ | async)" [formGroup]="additionalInfoForm">
  <h4 style="margin-top: 1.5rem">weitere Angaben zum Objekt</h4>
  <div class="wrapper">
    <div class="col">
      <div fxLayout="row" fxFlexAlign="stretch">
        <mat-checkbox formControlName="isNewBuilding">ist ein Neubau</mat-checkbox>
      </div>
    </div>
  </div>
  <div class="wrapper" style="margin-top: 1rem">
    <div class="col" fxFlex="50">
      <mat-form-field appearance="outline">
        <mat-label>Art des Gebäudes</mat-label>
        <mat-select formControlName="buildingType" (selectionChange)="changeObjectType()">
          <mat-option
            *ngFor="let ele of commissioningDataService.getCommissioningPowerObjectTypeType()"
            [value]="ele.value">
            {{ ele.displayName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="wrapper" *ngIf="additionalInfoForm.controls['buildingType'].value == 'MultiHouse'">
    <div class="col">
      <mat-form-field appearance="outline">
        <mat-label>Anzahl der Wohnungen</mat-label>
        <input matInput type="number" min="0" formControlName="numberOfFlats" />
      </mat-form-field>
    </div>
    <div class="col">
      <mat-form-field appearance="outline">
        <mat-label>Anzahl sonstiger Anschlussnutzer</mat-label>
        <input matInput type="number" min="0" formControlName="numberOfOtherUsers" />
      </mat-form-field>
    </div>
  </div>
  <div class="wrapper" *ngIf="additionalInfoForm.controls['buildingType'].value == 'NonResidential'">
    <div class="col">
      <mat-form-field fxFlex="50" appearance="outline" *ngIf="objectUsages$ | async as objectUsages">
        <mat-label>Nutzungsart des Objekts</mat-label>
        <mat-select formControlName="objectUsage" *ngIf="objectUsages?.length > 0">
          <mat-option *ngFor="let type of objectUsages" [value]="type.description">
            {{ type.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field fxFlex="50" appearance="outline" *ngIf="!(objectUsages$ | async)">
        <mat-label>Nutzungsart des Objekts</mat-label>
        <input matInput type="text" formControlName="objectUsage" />
      </mat-form-field>
    </div>
    <div class="col">
      <mat-form-field appearance="outline">
        <mat-label>Anzahl der Anschlussnutzer</mat-label>
        <input matInput type="number" min="0" formControlName="numberOfUsers" />
      </mat-form-field>
    </div>
  </div>
</form>
